import {useEffect, useState} from "react";
import PlayerSceneView from "@/player/view/PlayerSceneView.tsx";
import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";
import {preloadImages} from "@/images/ImageCache.ts";
import {srcUrl} from "@/api/ImageApi.ts";
import {useSceneQuery} from "@/scenes/SceneQueries.ts";

export default function PlayerSceneBoundary({sceneId, onReady, onError}: {
    sceneId: string;
    onReady?: () => void;
    onError?: () => void;
}) {
    const {campaign} = useCampaign();
    const query = useSceneQuery(sceneId);
    const [preparedKey, setPreparedKey] = useState<string>();
    const requestedKey = query.data ? `${sceneId}:${query.data.image.id}` : undefined;
    const scene = query.data?.campaignId === campaign.id && preparedKey === requestedKey ? query.data : undefined;
    const error = query.isError || (query.data !== undefined && query.data.campaignId !== campaign.id);

    useEffect(() => {
        const candidate = query.data;
        if (!candidate || candidate.campaignId !== campaign.id) return;
        let active = true;
        void preloadImages([srcUrl(candidate.image)]).then(() => {
            if (active) setPreparedKey(`${sceneId}:${candidate.image.id}`);
        });
        return () => { active = false; };
    }, [campaign.id, query.data, sceneId]);

    useEffect(() => {
        if (scene) onReady?.();
        else if (error) onError?.();
    }, [error, onError, onReady, scene]);

    if (error) {
        return <main className="grid size-full place-content-center">
            <p>Szene konnte nicht geladen werden.</p>
        </main>;
    }
    if (!scene) {
        return <main className="grid size-full place-content-center">
            <p role="status">Szene wird geladen…</p>
        </main>;
    }
    return <PlayerSceneView scene={scene}/>;
}
